<template>
    <div id="loadXlsx"></div>
</template>
<script>
    import XLSX from 'xlsx'
    export default {
        name: "loadXlsx",
        created: function () {
            //excelData loading
            this.loadXlsx()
        },
        methods:{
            /**
             * 初期データ読み込み
             */
            loadXlsx : function(){
                //価格データ取得
                const file = './data/data.xlsx';
                const req = new XMLHttpRequest()
                req.open('GET', file, true)
                req.responseType = 'arraybuffer'
                const scope = this

                req.onload = function () {
                    const data = new Uint8Array(req.response)
                    const workbook = XLSX.read(data, {type: 'array'})
                    let xlsx_data  = scope.to_json(workbook)
                    xlsx_data = scope.selectFormating(xlsx_data)
                    xlsx_data = scope.doubleFormating(xlsx_data)
                    //データを使いやすいよう品番で連想配列に変換
                    scope.$store.commit('loadXlsx', xlsx_data)
                    scope.$store.commit('is_loading', false)
                }
                req.send();
            },
            /**
             * ワークブックのデータをjsonに変換
             * @param workbook
             */
            to_json: function (workbook) {
                const result = {};
                workbook.SheetNames.forEach(function (sheetName) {
                    const roa = XLSX.utils.sheet_to_json(
                        workbook.Sheets[sheetName],
                        {
                            raw: true,
                        });
                    if (roa.length > 0) {
                        result[sheetName] = roa
                    }
                });
                return result
            },
            /**
             * 選択肢データを加工
             */
            selectFormating : function(xlsx_data){
                //console.log(xlsx_data.select)
                let return_obj = {}
                const select_data  = {}
                const select_sort  = {}
                const cap_data     = {}

                for(const cap in xlsx_data.cap_data){
                    const data = xlsx_data.cap_data[cap]
                    const cate = xlsx_data.cap_data[cap]['data']
                    if(typeof(cap_data[cate]) === 'undefined'){
                        cap_data[cate]  = {}
                    }
                    cap_data[cate]   = data
                }

                for(const select in xlsx_data.select){
                    const data = xlsx_data.select[select]
                    const cate = xlsx_data.select[select]['カテゴリー']
                    const item = xlsx_data.select[select]['機種名']
                    const cap  = xlsx_data.select[select]['キャップ']
                    const sort = xlsx_data.select[select]['順番']

                    if(typeof(select_data[cate]) === 'undefined'){
                        select_data[cate] = {}
                        select_sort[cate] = {}
                    }

                    if(typeof(select_data[cate][item]) === 'undefined'){
                        select_data[cate][item] = {}
                        select_sort[cate][item] = {}
                    }

                    if(typeof(select_sort[cate][item][sort]) === 'undefined') {
                        select_sort[cate][item][sort] = {}
                    }

                    if(typeof(select_data[cate][item][cap]) === 'undefined'){
                        select_data[cate][item][cap]       = {}
                        select_sort[cate][item][sort][cap] = {}
                    }

                    select_data[cate][item][cap]       = data
                    select_sort[cate][item][sort][cap] = data
                }
                //console.log(select_data)

                return_obj = xlsx_data
                return_obj.select = select_data
                return_obj.sort   = select_sort
                return_obj.cap    = cap_data

                return return_obj
            },
            /**
             * ダブル用フォーマット変更
             */
            doubleFormating : function(xlsx_data){
                //console.log(xlsx_data.select)
                let return_obj = {}
                const select_data  = {}
                for(const select in xlsx_data.double){
                    const data = xlsx_data.double[select]
                    const cate = xlsx_data.double[select]['機種名']
                    const item = xlsx_data.double[select]['基準']

                    if(typeof(select_data[cate]) === 'undefined'){
                        select_data[cate] = {}
                    }

                    if(typeof(select_data[cate][item]) === 'undefined'){
                        select_data[cate][item] = {}
                    }

                    select_data[cate][item] = data
                }
                //console.log(select_data)

                return_obj = xlsx_data
                return_obj.double = select_data
                return return_obj
            },
        }
    }
</script>